// -----------------------------------------------------------
//  AddSizeEvents
// -----------------------------------------------------------
const AddSizeEvents = {
  PREPARE: 'prints-builder-app.add-size-events.prepare',
  LAUNCH: 'prints-builder-app.add-size-events.launch',
};

// -----------------------------------------------------------
//  RemoveSizeEvents
// -----------------------------------------------------------
const RemoveSizeEvents = {
  REMOVE: 'prints-builder-app.remove-size-events.remove',
  SHOW_REMOVE_CONFIRMATION:
    'prints-builder-app.remove-size.show-remove-confirmation',
};

// -----------------------------------------------------------
//  UpdatePhotoEvents
// -----------------------------------------------------------
const UpdatePhotoEvents = {
  UPDATE: 'prints-builder-app.update-photo-events.update',
  REMOVE: 'prints-builder-app.update-photo-events.remove',
  REMOVE_MULTI_SELECT:
    'prints-builder-app.update-photo-events.remove-multi-select',
  SHOW_REMOVE_CONFIRMATION:
    'prints-builder-app.update-photo-events.show-remove-confirmation',
  ADD_TO_SIZE: 'prints-builder-app.update-photo-events.add-to-size',
  ADVANCED_EDIT:
    'prints-builder-app.update-photo-events-list-view-advanced-edit',
  ADVANCED_EDIT_CLOSE:
    'prints-builder-app.update-photo-events-list-view-advanced-edit-close',
  RESIZE: 'prints-builder-app.update-photo-events.resize',
  RESIZE_MULTI_SELECT:
    'prints-builder-app.update-photo-events.resize-multi-select',
  SHOW_INVALID_SIZES_MODAL:
    'prints-builder-app.update-photo-events.show-invalid-sizes-modal',
  SHOW_INVALID_DELIVERY_OPTION_MODAL:
    'prints-builder-app.update-photo-events.show-invalid-delivery-option-modal',
};

const DefaultsEvents = {
  CHANGE_SIZE: 'prints-builder-app.defaults-events.change-size',
};

export { AddSizeEvents, RemoveSizeEvents, UpdatePhotoEvents, DefaultsEvents };
